module.exports = __webpack_public_path__ + "static/media/anon_avatar_blue.c6466d68.svg";